export default "__VITE_ASSET__CqfxAv54__"